import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=196ed052&scoped=true&"
import script from "./input-file.vue?vue&type=script&lang=js&"
export * from "./input-file.vue?vue&type=script&lang=js&"
import style0 from "./input-file.vue?vue&type=style&index=0&id=196ed052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ed052",
  null
  
)

export default component.exports